module.exports = __webpack_public_path__ + "static/img/openMac.49d6501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liveVideo/openMac.png
// module id = vTqx
// module chunks = 1